import { Component, Injector } from '@angular/core';
import type { OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { IonicModule } from '@ionic/angular';
import { ViewBasePage } from '@shared/pages';
import type { TCampaignIncentive } from '@shared/models';
import { IncentiveFormat1Component } from '../campaignIncentiveFormat/IncentiveFormat1.component';
import { IncentiveFormat2Component } from '../campaignIncentiveFormat/IncentiveFormat2.component';

@Component({
    'selector': 'app-campaignFormatSelector',
    'templateUrl': './campaignFormatSelector.page.html',
    'styleUrls': ['./campaignFormatSelector.page.scss'],
    'standalone': true,
    'imports': [ CommonModule, FormsModule, IonicModule, IncentiveFormat1Component, IncentiveFormat2Component ]
})
export class CampaignFormatSelectorPage extends ViewBasePage implements OnInit {
    public selectedFormat: 'format1' | 'format2' | null = null;
    public incentives: TCampaignIncentive[] = [];
    public showPreview = false;

    constructor(injector: Injector) {
        super(injector);
    }

    public override async ngOnInit(): Promise<void> {
        super.ngOnInit();
        // Hardcoded data for now - will be replaced with Firebase later
        this.incentives = [
            {
                title: '10% Off First Ride',
                line1: 'Use code: FIRST10',
                line2: 'Valid until Dec 31, 2025',
                note: 'One time use only',
                uid: 'demo-incentive-1'
            },
            {
                title: 'Free Premium Membership',
                line1: 'Get 3 months free',
                line2: 'No credit card required',
                note: 'Cancel anytime',
                uid: 'demo-incentive-2'
            },
            {
                title: 'Refer a Friend',
                line1: 'Get $20 credit',
                line2: 'When they take their first ride',
                note: 'Unlimited referrals',
                uid: 'demo-incentive-3'
            }
        ];
    }

    public onFormatSelect(format: 'format1' | 'format2'): void {
        this.selectedFormat = format;
        this.showPreview = false;
    }

    public onShowPreview(): void {
        if (this.selectedFormat) {
            this.showPreview = true;
        }
    }

    public onBackToSelection(): void {
        this.showPreview = false;
    }
}
